import { AccountTransactionList } from "../../tlSalesOnAccount";

const LoanList = () => (
  <AccountTransactionList
    title="Loans"
    moduleId="LENLON"
    storageKey="lendingLoans.filters"
    accessPath="/api/lending/loans/access"
    statusPath="/api/lending/loans/status"
    printPath="/api/lending/loans/print"
    transactionPath="/App/LendingLoans"
    documentPrefix="LOAN"
    rowClassPrefix="loan"
    moneyFields={[
      "LoanAmount",
      "Principal",
      "InterestAmount",
      "TotalInterest",
      "Amortization",
      "MonthlyAmortization",
      "TotalAmount",
      "MaturityValue",
      "AmountPaid",
      "Balance",
    ]}
    showListSearch
    showReleaseAction
    releasePath="/api/lending/loans/release"
    showCollectionAction
    collectionPath="/api/lending/loans/collection"
    centeredErrors
    hideUnauthorizedActions
  />
);

export default LoanList;
